/**
 * Environment Configuration Override
 * Generated by centralized config system
 * Environment: development
 * Generated at: 2025-06-16T01:58:53.974Z
 */

export const ENVIRONMENT_CONFIG = {
    REACT_APP_AI_SERVER_URL: 'http://localhost:3000',
    REACT_APP_API_VERSION: 'v1',
    NODE_ENV: 'development'
};

// Override process.env if available
if (typeof process !== 'undefined' && process.env) {
    Object.keys(ENVIRONMENT_CONFIG).forEach(key => {
        if (!process.env[key]) {
            process.env[key] = ENVIRONMENT_CONFIG[key];
        }
    });
}

export default ENVIRONMENT_CONFIG;
